import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarStar } from '@fortawesome/pro-light-svg-icons/faCalendarStar';
import { SerializedPresaveWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../common/types';
import { useOpenSongPage } from '../../catalog/song/page/useOpenSongPage';
import { formatReleaseDay } from '../blocks/describeCatalogLinks';
import { catalogLinksMessages as m } from './catalogLinksMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for several parts; each part uses its own slice of it */
import styles from './CatalogLinks.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CatalogLinksSongBarProps {
  widget: SerializedPresaveWidget;
}

/** The song of the block (design c1, c2): title, artist, release day, status and "Change" (the song page). */
const CatalogLinksSongBarComponent: React.FC<CatalogLinksSongBarProps> = ({ widget }) => {
  const intl = useIntl();
  const openSongPage = useOpenSongPage();
  const { trackTitle, artistName, releaseDate, released, catalogItemUuid } = widget.data;
  const hasDate = releaseDate !== '' && !Number.isNaN(Date.parse(releaseDate));
  const change = useCallback(() => {
    if (typeof catalogItemUuid === 'string') {
      openSongPage(catalogItemUuid, 'details');
    }
  }, [catalogItemUuid, openSongPage]);

  return (
    <div className={styles.song}>
      <span className={styles.songIcon}>
        <FontAwesomeIcon icon={faCalendarStar} />
      </span>
      <span className={styles.songText}>
        <b>{trackTitle}</b>
        <small>
          {hasDate
            ? intl.formatMessage(m.songOut, { artist: artistName, date: formatReleaseDay(intl, releaseDate) })
            : intl.formatMessage(m.songNoDate, { artist: artistName })}
        </small>
      </span>
      <span className={clsx(styles.pill, released ? styles.pillOut : styles.pillUp)}>
        {intl.formatMessage(released ? m.out : m.upcoming)}
      </span>
      {typeof catalogItemUuid === 'string' && (
        <button type="button" className={styles.change} onClick={change}>
          {intl.formatMessage(m.change)}
        </button>
      )}
    </div>
  );
};

export const CatalogLinksSongBar = TypedMemo(CatalogLinksSongBarComponent);
